<template>
  <div v-if="showLoad" id="loader-container" style="z-index: 99999">
    <LoroPianaLogo class="col-md-3 col-md-offset-4_5 col-sm-6 col-sm-offset-3 col-xs-8 col-xs-offset-2 loader-logo"></LoroPianaLogo>
  </div>
</template>

<script>
import LoroPianaLogo from "@global/images/logos/LoroPianaLogo";
import CONST from "@/utils/Constants";
import { EventBus } from '@global/event-bus';

export default {
  name: "Loader",
  components: {LoroPianaLogo},
  data() {
    return {
      showLoad: false
    };
  },
  created() {
    EventBus.$on(CONST.EVENT.LOADER.SHOW, () => {
      this.showLoad = true;
    });
    EventBus.$on(CONST.EVENT.LOADER.HIDE, () => {
      this.showLoad = false;
    });
  }
}
</script>

<style scoped>
#loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
}

.loader-logo {
  top: 45%;
}
</style>



// WEBPACK FOOTER //
// src/global/loader/components/Loader.vue